/**
 * T038: Auth Service
 * API methods for authentication operations
 */

import { apiGet, apiPost, ApiError } from './api'

export interface User {
  id: string
  email: string
  name: string
}

export interface SignUpInput {
  email: string
  password: string
  name: string
}

export interface SignInInput {
  email: string
  password: string
}

export interface AuthResponse {
  user: User
}

export interface SignOutResponse {
  success: boolean
}

/**
 * Sign up a new user
 */
export async function signUp(input: SignUpInput): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/api/auth/sign-up', input)
}

/**
 * Sign in an existing user
 */
export async function signIn(input: SignInInput): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/api/auth/sign-in', input)
}

/**
 * Sign out the current user
 */
export async function signOut(): Promise<SignOutResponse> {
  return apiPost<SignOutResponse>('/api/auth/sign-out', {})
}

/**
 * Get the current authenticated user
 */
export async function getMe(): Promise<AuthResponse> {
  return apiGet<AuthResponse>('/api/auth/me')
}

export { ApiError }
